<template>
  <v-icon :color="updateIconColor(value)">
    {{ updateIcon(value) }}
  </v-icon>
</template>
<script>
export default {
  props: ["value"],
  methods: {
    updateIcon(value) {
      switch (value) {
        case 0:
          return "looks_one";
        case 1:
          return "looks_two";
        case 2:
          return "looks_3";
        case 3:
          return "looks_4";
      }
    },
    updateIconColor(value) {
      switch (value) {
        case 0:
          return "deep-purple lighten-2";
        case 1:
          return "indigo lighten-2";
        case 2:
          return "blue lighten-2";
        case 3:
          return "cyan lighten-2";
      }
    },
  },
};
</script>